import _PlaylistPlayRounded from "@mui/icons-material/PlaylistPlayRounded";
import React from 'react';
import { ButtonContainer, IconButtonLabel, IconButtonWrapper, withDropShadow } from 'app/components/tv/customControls/SharedCustomControlsStyles';
const StyledPlaylistPlayRounded = withDropShadow(_PlaylistPlayRounded);
export const PlaylistToggle = _ref => {
  let {
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement(IconButtonWrapper, {
    "data-sentry-element": "IconButtonWrapper",
    "data-sentry-component": "PlaylistToggle",
    "data-sentry-source-file": "PlaylistToggle.tsx"
  }, /*#__PURE__*/React.createElement(ButtonContainer, {
    onClick: onClick,
    title: "Playlist",
    noMargin: true,
    "data-sentry-element": "ButtonContainer",
    "data-sentry-source-file": "PlaylistToggle.tsx"
  }, /*#__PURE__*/React.createElement(StyledPlaylistPlayRounded, {
    color: 'icon-invert',
    "data-sentry-element": "StyledPlaylistPlayRounded",
    "data-sentry-source-file": "PlaylistToggle.tsx"
  })), /*#__PURE__*/React.createElement(IconButtonLabel, {
    variant: "body1",
    "data-sentry-element": "IconButtonLabel",
    "data-sentry-source-file": "PlaylistToggle.tsx"
  }, "Playlist"));
};